<script setup lang="ts">
defineProps<{
  right: boolean | None
}>()
</script>

<template>
  <slot v-if="!right" name="left" />
  <slot />
  <slot v-if="right" name="left" />
</template>
